import { Link } from "gatsby"
import React, { useState } from "react"
import { Container, Row, Col, Form, Button, Badge } from "react-bootstrap"
import Select from 'react-select'
import CodeBlock from "./home-demo-box"
import { element } from "prop-types"
import { ArrowRight } from "react-feather"

const axios = require('axios')

const demoResponse = `{
  "status": 200,
  "is_billed": true,
  "data": [
   {
    "type": "css",
    "selector": "h1",
    "results": [
     {
      "text": "Example Domain"
     }
    ]
   },
   {
    "type": "css",
    "selector": "a",
    "results": [
     {
      "text": "More information...",
      "attributes": [
       {
        "name": "href",
        "value": "https://www.iana.org/domains/example"
       }
      ]
     }
    ]
   }
  ],
  "html": null
 }`;

const codeExampleLanguages = [
  { value: 'css', label: 'CSS' },
  { value: 'xpath', label: 'XPath' }
];

const HomeDemo = () => {
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [isUserOnInput, setIsUserOnInput] = useState(false);
  const [apiResponse, setApiResponse] = useState(demoResponse);

  const [demoDropDownSelector1, setDemoDropDownSelector1] = useState({ value: 'css', label: 'CSS' });
  const [demoDropDownSelector2, setDemoDropDownSelector2] = useState({ value: 'css', label: 'CSS' });
  const [demoDropDownSelector3, setDemoDropDownSelector3] = useState({ value: 'css', label: 'CSS' });

  const [demoSelector1, setDemoSelector1] = useState('h1');
  const [demoSelector2, setDemoSelector2] = useState('div > p:nth-child(2)');
  const [demoSelector3, setDemoSelector3] = useState('a');

  const [url, setUrl] = useState('');
  const [errMessage, setErrMessage] = useState();
  const [notifClasses, setNotifClasses] = useState();

  const handleScrape = () => {
    setErrMessage('')

    //let apiUrl = process.env.DEMO_API_URL;
    let apiUrl = "https://api.scrapeowl.com/v1/demo";
    let elements = [
      {
        "selector": "h1"
      },
      {
        "selector": "a",
        "attributes": true
      }
    ];

    /*if (demoSelector1 && demoDropDownSelector1) {
      elements.push({
        type: demoDropDownSelector1.value,
        selector: demoSelector1
      });
    }

    if (demoSelector2 && demoDropDownSelector2) {
      elements.push({
        type: demoDropDownSelector2.value,
        selector: demoSelector2
      });
    }

    if (demoSelector3 && demoDropDownSelector3) {
      elements.push({
        type: demoDropDownSelector3.value,
        selector: demoSelector3
      });
    }*/

    var pattern = /^((http|https):\/\/)/;

    if(!url) {
      setErrMessage('URL is required');
      return ;
    } else if(!pattern.test(url.trim())) {
      setErrMessage("URL should begin with http:// or https://");
      return ;
    }

    setIsLoadingButton(true);
    axios.post(apiUrl, {
      url: url.trim(),
      elements: elements,
      render_js: true,
      premium_proxies: true
    })
      .then(function (response) {
        setApiResponse(JSON.stringify(response.data, null, " "));
      })
      .catch(function (error) {
        console.log(error);
        setNotifClasses('notification float is-link is-light-1');
        if (error.response) {
          if (429 == error.response.status) {
            if(error.response && error.response.hasOwnProperty('data')) {
              setApiResponse(JSON.stringify(error.response.data, null, " "));
            }

            setErrMessage('API rate limit exceeded.');
          }
        } else {
          if(error.response && error.response.hasOwnProperty('data')) {
            setApiResponse(JSON.stringify(error.response.data, null, " "));
          }
          setErrMessage('Something went wrong.');
        }
        // Wait for 3 seconds before closing the notification
        /*setTimeout(function () {
          // Add hide class so we have transition
          let currentClasses = notifClasses + ' hide';
          setNotifClasses(currentClasses);

          // Clean the flash message so the notification can be used again
          setTimeout(function () {
            setErrMessage('');
          }, 500);
        }, 3000);*/
      })
      .finally(function () {
        setIsLoadingButton(false);
        // always executed
      });
  }

  return (
    <React.Fragment>
      {
        /*errMessage &&
        <div className={notifClasses}>
          {errMessage}
        </div>*/
      }

      <div id="try-me" className="demo-section">

        <Row>

          <Col className="demo-col-1" xs="12" sm="12" md="5" lg="5">

            <Row>
              <span className="sectionite">
                try it to believe
            </span>
              <h2>Try the Extraction API </h2>
            </Row>
            <Row>
              <p className="big-p">This demo automatically extracts h1, and a tags from the page. If you want to extract other elements, you need to create an account and start using our API, which allows you to submit a request URL with the elements you want, whether you want to render Javascript using the <Badge className="demo-badge">render_js</Badge> feature and run Javascript using the <Badge className="demo-badge">custom_js</Badge> feature.</p>
              {
                /*
                <p className="big-p">Submit a request URL with the elements you want using the <Badge className="demo-badge">elements</Badge> feature, whether you want to render Javascript using the <Badge className="demo-badge">render_js</Badge> feature and run Javascript using the <Badge className="demo-badge">custom_js</Badge> feature.</p>
                */
              }
            </Row>
            <div className="api-features">
              <Row className="api-feature">
                <span>
                  <Badge className="demo-badge">elements</Badge>

                </span>
                <span className="api-feature-description">
                  The implementation on the right is preconfigured to retrieve h1 headings and a link tag elements from any website that you enter. Want to configure your own? Start with our <Link to="/docs">API docs.</Link>
                </span>

              </Row>
              <Row className="api-feature">
                <span>
                  <Badge className="demo-badge">render_js</Badge>

                </span>
                <span className="api-feature-description">
                  Allow applications that load content aynschronously (after initial page load) to fully load pages before extracting the elements. You can also use the <Badge className="badge">wait_for</Badge> API feature.
                      </span>

              </Row>
              <Row className="api-feature">
                <span>
                  <Badge className="demo-badge">custom_js</Badge>

                </span>
                <span className="api-feature-description">
                  Sometimes you might want to scroll down a page, click a button, or submit a form. You can do this by running custom JS prior to extraction of content using this API feature.
                      </span>

              </Row>
            </div>

            <Link to="/docs" className="secondary-button" style={{ margin: "0", textAlign: "left" }}>Learn how to use these API features<ArrowRight className="titular-arrow" /></Link>

          </Col>

          <Col xs="12" sm="12" md="7" lg="7">

            <Row>
              <Col md="12" lg="12" className="demo-section-1">

                <div className="input-group" className={`input-group${isUserOnInput ? ' active' : ''}`}>

                  <input
                    type="url"
                    className={ 'form-control url-box' + ( errMessage ? ' error' : '' ) }
                    placeholder="https://example.com"
                    value={url}
                    onChange={e => { setUrl(e.target.value) }}
                    onFocus={e => { setIsUserOnInput(true) }}
                    onBlur={e => { setIsUserOnInput(false) }}
                  />

                  <div className="button-container">
                    <span className="button-span">
                      <Button className={`cta-button scrape-button ${isLoadingButton ? 'loading' : ''}`} onClick={handleScrape} >Extract Elements</Button>
                    </span>
                  </div>

                </div>

                {
                  errMessage &&
                  <div className="error">
                    {errMessage}
                  </div>
                }

                <CodeBlock
                  code={apiResponse}
                  selectedLanguage={{ value: 'json', label: 'JSON' }}
                  title="API RESPONSE"
                  showLineNumbers={false}
                  hasLanguageSelector={false}
                  hasMultipleLanguages={false}
                  hasCopyCodeButton={true}
                  clipBoardButtonSize={16}
                  wrapLines={true}
                />
              </Col>
            </Row>
          </Col>

        </Row>

      </div>


      { /*
        <div className="demo-section">
          <Container>
            <Row>
              <Col md="12" lg="12">
                <h3>What does ScrapeOwl's API Look Like? </h3>
              </Col>
            </Row>

            <Row>
              <Col md="12" lg="6" className="demo-section-1">
                <input
                  type="url"
                  className="form-control url-box"
                  placeholder="Enter any URL"
                  value={url}
                  onChange={e => { setUrl(e.target.value) }}
                />

                <div>
                  <Row>
                    <Col xs="5" sm="4" md="4" lg="4">
                      <Select
                        isSearchable={false}
                        value={demoDropDownSelector1}
                        options={codeExampleLanguages}
                        onChange={(selectedOption) => { setDemoDropDownSelector1(selectedOption) }}
                      />
                    </Col>
                    <Col xs="7" sm="8" md="8" lg="8">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Selector"
                        value={demoSelector1}
                        onChange={(e) => { setDemoSelector1(e.target.value) }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="5" sm="4" md="4" lg="4">
                      <Select
                        isSearchable={false}
                        value={demoDropDownSelector2}
                        options={codeExampleLanguages}
                        onChange={(selectedOption) => { setDemoDropDownSelector2(selectedOption) }}
                      />
                    </Col>
                    <Col xs="7" sm="8" md="8" lg="8">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Selector"
                        value={demoSelector2}
                        onChange={(e) => { setDemoSelector2(e.target.value) }}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs="5" sm="4" md="4" lg="4">
                      <Select
                        isSearchable={false}
                        value={demoDropDownSelector3}
                        options={codeExampleLanguages}
                        onChange={(selectedOption) => { setDemoDropDownSelector3(selectedOption) }}
                      />
                    </Col>
                    <Col xs="7" sm="8" md="8" lg="8">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Selector"
                        value={demoSelector3}
                        showLineNumbers={false}
                        onChange={(e) => { setDemoSelector3(e.target.value) }}
                      />
                    </Col>
                  </Row>

                  <Button className={`black-button scrape-button ${isLoadingButton ? 'loading' : ''}`} onClick={handleScrape} >Scrape</Button>
                </div>
              </Col>
              <Col md="12" lg="6" className="demo-section-2">
                <CodeBlock
                  code={apiResponse}
                  selectedLanguage={{ value: 'json', label: 'JSON' }}
                  title="API RESPONSE"
                  hasLanguageSelector={false}
                  hasMultipleLanguages={false}
                  hasCopyCodeButton={true}
                  clipBoardButtonSize={16}
                />
              </Col>
            </Row>

          </Container>
        </div>
      */ }
    </React.Fragment>
  )
}

export default HomeDemo
